import { AWSError } from 'aws-sdk';

export class Errors {
  static NOT_AUTHORIZED = {
    code: 'NotAuthorizedException',
    message: 'Your request could not be authorized. Please try again.'
  } as AWSError;

  static USER_NOT_FOUND = {
    code: 'UserNotFoundException',
    message: 'Your request could not be authorized. Please try again.'
  } as AWSError;

  static CODE_MISMATCH = {
    code: 'CodeMismatchException',
    message: 'Invalid authorization code. Please try again.'
  } as AWSError;

  static EXPIRED_CODE = {
    code: 'ExpiredCodeException',
    message: 'Expired authorization code. Please try again.'
  } as AWSError;

  static INVALID_PARAMETER_TYPE = {
    code: 'InvalidParameterType',
    message: 'Invalid parameter type. Please try again.'
  } as AWSError;

  static INVALID_PARAMETER = {
    code: 'InvalidParameterException',
    message: 'Invalid parameter. Please try again.'
  } as AWSError;

  static INVALID_PASSWORD = {
    code: 'InvalidPasswordException',
    message: 'Invalid password entered. Please try again.'
  } as AWSError;

  static LIMIT_EXCEEDED = {
    code: 'LimitExceededException',
    message: 'Request limit exceeded. Please try again later.'
  } as AWSError;

  static PASSWORD_EXCEPTION = {
    code: 'PasswordException',
    message: 'Your password did not meet the criteria. Please try again.'
  } as AWSError;

  static PASSWORD_RESET_REQUIRED = {
    code: 'PasswordResetRequiredException',
    message: 'Your request could not be authorized. Please try again.'
  } as AWSError;

  static ACCOUNT_LOCKED_EXCEPTION = {
    code: 'AccountLockedException',
    message:
      'Your account has been locked. Please contact your administrator to unlock it.'
  } as AWSError;
  static FIVE_PREVIOUS_PASSWORD = {
    code: 'PreviousPasswordException',
    message:
      'Your new password cannot be the same as any of your previous five passwords. Try again.'
  } as AWSError;

  static GENERIC = {
    code: '',
    message:
      'Your request could not be completed. Please contact system administrator.'
  } as AWSError;
}
